exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.meter_name_required[data-v-7f59767e] {\n    border-color: red !important;\n}\n.meter_name_required_feedback[data-v-7f59767e] {\n    display: block;\n    background: #dcd0cb;\n    padding: 8px;\n    font-size: 14px;\n    color: #6d1717;\n}\n.is-loading[data-v-7f59767e] {\n    opacity: .4;\n}\n.meter-delete-btn[data-v-7f59767e] {\n    color: #e9ecef;\n    font-size: .7rem;\n}\n", ""]);

// exports
